import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AdminFormView from "@/pages/AdminFormView";
import SuperAdmin from "@/pages/SuperAdmin";
import SuperAdminClinic from "@/pages/SuperAdminClinic";
import AdminSettings from "@/pages/AdminSettings";
import Onboarding from "@/pages/Onboarding";
import CheckinLanding from "@/pages/CheckinLanding";
import MyCompanies from "@/pages/MyCompanies";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/c/:slug" element={<CheckinLanding />} />
      <Route path="/dashboard" element={<ProtectedRoute requireRole="patient"><Dashboard /></ProtectedRoute>} />
      <Route path="/my-companies" element={<ProtectedRoute requireRole="patient"><MyCompanies /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute requireRole="clinic_admin"><Admin /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute requireRole="clinic_admin"><AdminSettings /></ProtectedRoute>} />
      <Route path="/admin/onboarding" element={<ProtectedRoute requireRole="clinic_admin"><Onboarding /></ProtectedRoute>} />
      <Route path="/admin/:userId" element={<ProtectedRoute requireRole="clinic_admin"><AdminFormView /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute requireRole="clinic_admin"><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute requireRole="clinic_admin"><PaymentCancel /></ProtectedRoute>} />
      <Route path="/super" element={<ProtectedRoute requireRole="super_admin"><SuperAdmin /></ProtectedRoute>} />
      <Route path="/super/clinics/:clinicId" element={<ProtectedRoute requireRole="super_admin"><SuperAdminClinic /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
